import { useState } from 'react';
import StickyHeader from '../feature/StickyHeader';
import ConsultationModal from '../feature/ConsultationModal';
import Footer from '../feature/Footer';
import TrustBar from '../../pages/home/components/TrustBar';
import ProcessSection from '../../pages/home/components/ProcessSection';
import ServiceAreas from '../../pages/home/components/ServiceAreas';
import Testimonials from '../../pages/home/components/Testimonials';
import FinalCTA from '../../pages/home/components/FinalCTA';
import InnerHeroSection from '../sections/InnerHeroSection';
import InnerServicesSection from '../sections/InnerServicesSection';
import InnerAIAnswerBlock from '../sections/InnerAIAnswerBlock';
import InnerWhyChooseUs from '../sections/InnerWhyChooseUs';
import InnerFAQSection from '../sections/InnerFAQSection';

interface ServiceItem {
  icon: string;
  title: string;
  desc: string;
}

interface AICol {
  title: string;
  items: string[];
}

interface Reason {
  icon: string;
  title: string;
  desc: string;
}

interface FAQItem {
  question: string;
  answer: string;
}

export interface InnerPageConfig {
  hero: {
    badge: string;
    h1: string;
    subtitle: string;
    bgImage: string;
  };
  services: {
    sectionLabel: string;
    h2: string;
    intro?: string;
    items: ServiceItem[];
    featureImage: string;
    featureTitle: string;
    featureDesc: string;
  };
  aiBlock: {
    h2: string;
    intro: string;
    col1: AICol;
    col2: AICol;
    col3Items?: { step: string; label: string; desc: string; }[];
  };
  whyChooseUs: {
    label?: string;
    h2: string;
    desc?: string;
    reasons: Reason[];
    images: string[];
  };
  faqs: FAQItem[];
}

interface InnerPageTemplateProps {
  config: InnerPageConfig;
}

export default function InnerPageTemplate({ config }: InnerPageTemplateProps) {
  const [consultationOpen, setConsultationOpen] = useState(false);

  return (
    <div className="min-h-screen bg-offWhite font-body">
      <StickyHeader onOpenConsultation={() => setConsultationOpen(true)} />
      <ConsultationModal isOpen={consultationOpen} onClose={() => setConsultationOpen(false)} />

      <main>
        {/* Section 1: Hero */}
        <InnerHeroSection
          {...config.hero}
          onOpenConsultation={() => setConsultationOpen(true)}
        />

        {/* Section 2: Trust Bar */}
        <TrustBar />

        {/* Section 3: Services/Content */}
        <InnerServicesSection
          {...config.services}
          onOpenConsultation={() => setConsultationOpen(true)}
        />

        {/* Section 4: AI Answer Block */}
        <InnerAIAnswerBlock {...config.aiBlock} />

        {/* Section 5: Process */}
        <ProcessSection onOpenConsultation={() => setConsultationOpen(true)} />

        {/* Section 6: Why Choose Us */}
        <InnerWhyChooseUs {...config.whyChooseUs} />

        {/* Section 7: Service Areas */}
        <ServiceAreas />

        {/* Section 8: Testimonials */}
        <Testimonials onOpenConsultation={() => setConsultationOpen(true)} />

        {/* Section 9: FAQ */}
        <InnerFAQSection faqs={config.faqs} />

        {/* Section 10: Final CTA */}
        <FinalCTA onOpenConsultation={() => setConsultationOpen(true)} />
      </main>

      <Footer />
    </div>
  );
}
